
import AboutImage from "../../assets/SalifoFoto.jpg"
import data from "./data";
import Card from "../../components/Card";
import CV from "../../assets/Salifo-BanceCV-2023.pdf";
import './about.css';
import React, { Component }  from 'react';
import {AiOutlineCloudDownload} from "react-icons/ai";


const About = () => {
  return (
   <section id="about" data-aos="fade-in">
 <div className="container about__container">
<div className="about__left">

 <div className="about__portrait">
  <img src={AboutImage} alt="Salifo About image" className="aboutFoto" />
 </div>

</div>


<div className="about__right">

<h2>About me</h2>

<p className="about_text">

<span className="Hey">Hi, I’m Salifo</span> 

<br />
I'm a recent Computer Science graduate from <span>Manchester Metropolitan University </span>
where I achieved a First Class Honours degree.
I’m passionate about technology and driven by a strong desire 
to make a positive impact in the tech industry</p>
 <p className="about_text">

<span className="workDesc">
Over the past few years, I’ve developed a solid foundation in core computer 
science principles through 3 years of hands-on experience in university labs,
 gaining practical skills in areas such as programming, AI, computer networks, 
 cybersecurity, operating systems, and data structures & algorithms. <br />
Currently working as an IT Service Desk Analyst, where I have strengthened my problem-solving, 
troubleshooting, and communication skills. 
Eager to grow in a junior .NET or 
cloud engineering role and contribute to 
meaningful projects while continuing to develop my technical expertise.


 please download my CV below 
 <br />
</span>
<br />

I have a strong work ethic, also I'm a team player who can work unsupervised or using initiative and can
remain calm under pressure and can organise tasks to ensure
deadlines are met on time.

I have high level of accuracy and practical IT /Software skills
with a willingness to undertake further learning and training.<br />
<br />
Outside of tech, I am a sports enthusiast with a particular love for football. 
I spent six years playing in a professional academy in Italy during my youth, 
and today I continue to stay active through friendly matches 
and regular running which helps me maintain a healthy and balanced lifestyle.
</p>
 <a href={CV} download className="btn primary"> <AiOutlineCloudDownload/> Download CV</a>

<div className="about__cards">
  {
    data.map(item => (
   <Card key={item.id} className="about__card">
    <span className= "about__card-icon" >{item.icon}</span>
    <h5>{item.title}</h5>
    <small>{item.desc}</small>
   </Card>
    ))
  }
</div>

</div>

 </div>



   </section>
  );
}

export default About;